export const normalizeWastage = (
  value: string | undefined,
  material: string
): Wastage => {
  const normalizedValue = (value ?? "").trim();
  const normalizedMaterial = material?.toLowerCase();

  if (normalizedMaterial === "silver") {
    return "NO_WASTAGE";
  }

  if (normalizedValue === "810" || normalizedValue === "825") {
    return normalizedValue as Wastage;
  }

  return "825";
};
